import { render, staticRenderFns } from "./AppointmentCancel.vue?vue&type=template&id=fe8875ea"
import script from "./AppointmentCancel.vue?vue&type=script&lang=js"
export * from "./AppointmentCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports